import React from "react"
//import styled, { css } from 'styled-components'
import ReactHtmlParser from "react-html-parser"
//import Img from 'gatsby-image'
import tw, { styled } from "twin.macro"
import Pill, { Style as ButtonPillStyle } from "@ui-kit/atoms/button/pill"

import { Download } from "react-feather"
import { proseStyle } from "./styles"
//const cheerio = require('cheerio');

//import 'core-js/modules/es7.string.match-all'

const Prose = ({
  element = "div",
  html = "",
  wysiwygImages = [],
  wysiwygFiles = [],
  wysiwygVideos = [],
  wysiwygHTMLVideos = [],
  env = process.env.GATSBY_SITE,
  ...props
}) => {
  //const [ markup, setMarkup ] = useState(html);
  html = html.replaceAll(`/${env}/`, "/")

  /*const Elem = styled(element).attrs(props => ({

    }))`
        ${Styles};
        .btn-primary {
            ${ButtonPillStyle};
            border-color: ${props => props.theme.colors.primary};
            background-color: ${props => props.theme.colors.primary};
        }
    `*/

  const Elem = proseStyle(element)

  const regexp = /data-entity-uuid/gm
  const matches = [...html.matchAll(regexp)]

  if (matches.length) {
    html = new ReactHtmlParser(html, {
      transform: function transform(node) {
        if (node.name === "a") {
          const type = node?.attribs["data-entity-type"] || null

          if (type === "media") {
            const mediaId = node?.attribs["data-entity-uuid"]
            const media = wysiwygFiles.find((file) => file.id === mediaId)
            if (media) {
              return (
                <a
                  key={"a"}
                  href={media.relationships.media.localFile.publicURL}
                  download={media.name}
                >
                  {node.children.at(0).data}
                </a>
              )
            }
          }
        }

        if (node.name === "drupal-entity" || node.name === "drupal-media") {
          const type = node?.attribs["data-embed-button"] || null

          const mediaId = node.attribs["data-entity-uuid"]

          const image = wysiwygImages.find((img) => img.id === mediaId)

          if (image) {
            return (
              <figure key={"figure"}>
                <picture>
                  <img
                    loading="lazy"
                    src={encodeURI(
                      image.relationships.media.localFile.publicURL
                    )}
                    width={image.meta.width}
                    height={image.meta.height}
                    alt={image.meta.alt}
                  />
                </picture>
              </figure>
            )
          }

          const file = wysiwygFiles.find((file) => file.id === mediaId)

          if (file) {
            return (
              <Pill elem={"p"} key={"pill"} className="btn--icon">
                <a
                  href={encodeURI(file.relationships.media.localFile.publicURL)}
                  download
                >
                  <Download />
                  <span>{file.name}</span>
                </a>
                <small>
                  {file.relationships.media.localFile.extension} |{" "}
                  {file.relationships.media.localFile.prettySize}
                </small>
              </Pill>
            )
          }

          const video = wysiwygVideos.find((file) => file.id === mediaId)

          if (video) {
            const youtubeEmbed = require("youtube-embed")
            const embed = youtubeEmbed(video.url)
            return (
              <figure key={"figure"}>
                <iframe
                  src={embed}
                  border="0"
                  width="800"
                  className="w-full h-auto bg-transparent align-top border-0 aspect-video"
                />
              </figure>
            )
          }

          const htmlVideo = wysiwygHTMLVideos.find(
            (file) => file.id === mediaId
          )

          if (htmlVideo) {
            return (
              <figure key={"figure"}>
                <video
                  poster={htmlVideo.r.poster?.file?.publicURL}
                  controls
                  tw="w-full h-auto align-top border-0"
                >
                  <source src={htmlVideo.r.video.file.publicURL} />
                </video>
              </figure>
            )
          }
        }
      },
    })

    html = <Elem {...props}>{html.map((tag, i) => tag)}</Elem>
  } else {
    html = (
      <Elem
        {...props}
        dangerouslySetInnerHTML={{ __html: html.replaceAll("&nbsp;", " ") }}
      />
    )
  }

  return html
}
export default Prose
